import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';

import { SearchResult } from '../search-result';

const messages = defineMessages({
	loadingResult: {
		id: 'search_result_skeleton_loading_result',
		defaultMessage: 'Loading result',
		description: 'Accessible label for loading search result skeleton',
	},
});

const commonStyles = xcss({
	backgroundColor: 'color.background.accent.gray.subtlest',
});

const skeletonTextStyles = xcss({
	borderRadius: 'radius.full',
});

const titleStyles = xcss({
	width: '280px',
	height: token('space.200'),
	marginBottom: 'space.050',
});

const iconStyles = xcss({
	width: 'size.400',
	height: 'size.400',
	borderRadius: 'radius.small',
});

const containerStyles = xcss({
	pointerEvents: 'none',
});

const descriptionContainerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	rowGap: 'space.100',
});

const descriptionStyles = xcss({
	width: '100%',
	height: token('space.150'),
});

const metadataStyles = xcss({
	width: '200px',
	height: token('space.150'),
	marginBottom: 'space.050',
});

const metadataItemStyles = xcss({
	height: token('space.150'),
	borderRadius: 'radius.large',
});

const narrowMetadataItemStyles = xcss({
	width: '50px',
});

const wideMetadataItemStyles = xcss({
	width: '100px',
});

export const MetaDataItemSkeleton = (): React.JSX.Element => {
	return (
		<Box
			testId="metadata-item-skeleton"
			xcss={[commonStyles, metadataItemStyles, narrowMetadataItemStyles]}
		/>
	);
};

export const MetaDataItemSkeletonWide = (): React.JSX.Element => {
	return (
		<Box
			testId="metadata-item-skeleton-wide"
			xcss={[commonStyles, metadataItemStyles, wideMetadataItemStyles]}
		/>
	);
};

export const SearchResultSkeleton = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={containerStyles}>
			<SearchResult
				description={
					<Box xcss={[descriptionContainerStyles]}>
						<Box xcss={[commonStyles, skeletonTextStyles, descriptionStyles]} />
						<Box xcss={[commonStyles, skeletonTextStyles, descriptionStyles]} />
					</Box>
				}
				icon={<Box xcss={[commonStyles, iconStyles]} />}
				title={
					<>
						<VisuallyHidden>{formatMessage(messages.loadingResult)}</VisuallyHidden>
						<Box xcss={[commonStyles, skeletonTextStyles, titleStyles]} />
					</>
				}
				headerMetadataParts={[<Box xcss={[commonStyles, skeletonTextStyles, metadataStyles]} />]}
				// TODO: QS-7036 consolidate the logic of the loading state as it's now split between
				//  this component and the SearchResult component (hence the prop)
				isLoadingSkeleton={true}
			/>
		</Box>
	);
};
